"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/ordermade/v1/ems_ordermade_error.proto (package spwn.ordermade.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMSOrdermadeServiceEditOrdermadeProductDesignError = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailError = exports.EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * UpdateOrdermadeProductDetailのエラー詳細（ConnectErrorのdetailsで返す）
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason
 */
var EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason;
(function (EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason) {
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED = 0;
     */
    EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason[EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason["EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED";
    /**
     * 申請中の商品詳細は編集できない
     *
     * @generated from enum value: EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE = 1;
     */
    EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason[EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason["EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE"] = 1] = "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE";
})(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason || (exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason, "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason", [
    { no: 0, name: "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE" },
]);
/**
 * EditOrdermadeProductDesignのエラー詳細（ConnectErrorのdetailsで返す）
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason
 */
var EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason;
(function (EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason) {
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_UNSPECIFIED = 0;
     */
    EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason[EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason["EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_UNSPECIFIED";
    /**
     * 申請中/承認済みの商品は編集できない（未申請/却下のみ編集可）
     *
     * @generated from enum value: EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_PRODUCT_NOT_EDITABLE = 1;
     */
    EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason[EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason["EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_PRODUCT_NOT_EDITABLE"] = 1] = "EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_PRODUCT_NOT_EDITABLE";
})(EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason = exports.EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason || (exports.EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason, "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason", [
    { no: 0, name: "EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_PRODUCT_NOT_EDITABLE" },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailError
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason reason = 1;
         */
        this.reason = EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason.EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailError, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailError = EMSOrdermadeServiceUpdateOrdermadeProductDetailError;
EMSOrdermadeServiceUpdateOrdermadeProductDetailError.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailError.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailError";
EMSOrdermadeServiceUpdateOrdermadeProductDetailError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason) },
]);
/**
 * EditOrdermadeProductDesignのエラー詳細本体
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignError
 */
class EMSOrdermadeServiceEditOrdermadeProductDesignError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason reason = 1;
         */
        this.reason = EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason.EMS_ORDERMADE_SERVICE_EDIT_ORDERMADE_PRODUCT_DESIGN_ERROR_REASON_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceEditOrdermadeProductDesignError, a, b);
    }
}
exports.EMSOrdermadeServiceEditOrdermadeProductDesignError = EMSOrdermadeServiceEditOrdermadeProductDesignError;
EMSOrdermadeServiceEditOrdermadeProductDesignError.runtime = protobuf_1.proto3;
EMSOrdermadeServiceEditOrdermadeProductDesignError.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignError";
EMSOrdermadeServiceEditOrdermadeProductDesignError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeServiceEditOrdermadeProductDesignErrorReason) },
]);
//# sourceMappingURL=ems_ordermade_error_pb.js.map